<template>
  <pt-user-roles class="pt-user-roles__withData" @rolesDelete="rolesDelete" ref="table"></pt-user-roles>
</template>

<script>
import PtUserRoles from './index'
export default {
  name: 'pt-user-roles__withData',
  components: {
    'pt-user-roles': PtUserRoles
  },
  methods: {
    rolesDelete (id) {
      this.$store.dispatch('rolesDelete', id).then(res => {
        this.$message.success('删除角色成功')
        this.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除角色失败')
      })
    },
    getTableData () {
      this.$refs.table.getTableData()
    }
  }
}
</script>
